module.exports = __webpack_public_path__ + "./img/stock-low.904018e29af1a619ac73b8232f4406db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stock-low.png
// module id = ./src/assets/img/stock-low.png
// module chunks = 11